module.exports = __webpack_public_path__ + "img/c-14.08e3d31a.jpg";